export interface CreditIQTokenBundle {
    accessToken: string;
    refreshToken: string;
    expiresIn: number;
}

export enum CreditIQEnvironment {
    staging = "staging",
    prod = "prod",
}

export interface CreditIQ {
    sourceOrgId: string;
    destinationOrgId: string;
    environment: CreditIQEnvironment;
}
